export default __webpack_public_path__ + "static/media/Busy-Pickle-Gif.31239719.gif";